module.exports = __webpack_public_path__ + "img/icon-7.20ad770e.png";